<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">邮箱信息</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="mailinfoForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="邮箱帐号" prop="account">
              <Input v-model="form.account" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="邮箱密码" prop="password">
              <Input v-model="form.password" :disabled="disable" type="password"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit"  v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'mailinfo-info',
  data () {
    return {
      form: {},
      isShow: false,
      type: 'add',
      disable: false,
      ruleValidate: {
        id: [
          { required: true, message: 'ID不允许为空', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '邮箱帐号不允许为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '邮箱密码不允许为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '0-未使用不允许为空', trigger: 'blur' }
        ],
        crtUserId: [
          { required: true, message: '创建用户Id不允许为空', trigger: 'blur' }
        ],
        crtTime: [
          { required: true, message: 'CrtTime不允许为空', trigger: 'blur' }
        ],
        mdfUserId: [
          { required: true, message: 'MdfUserId不允许为空', trigger: 'blur' }
        ],
        mdfTime: [
          { required: true, message: 'MdfTime不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.$refs.mailinfoForm.validate((valid) => {
        if (valid) {
          switch (this.type) {
            case 'create':
              this.C('mailinfo', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
            case 'update':
              this.U('mailinfo', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
          }
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  },
  mounted: function () {
  }
}
</script>
